<script setup lang="ts">
  import useCpBem from '~/composables/useCpBem';
  import CpNavMenuMainCategoryCard
    from '~/components/cp/CpNavMenu/CpNavMenuMainCategoryCard/CpNavMenuMainCategoryCard.vue';
  import type {ICatMan} from '~/types';
  import {useCategoriesMenu} from '~/composables/useCategoriesMenu';
  import {useCategoriesMenuStore} from '~/stores/categoriesMenuStore';

  const {b} = useCpBem('cp-nav-menu-main-categories');
  const hasSubcategories = (category: ICatMan) => category.hasSubCategories;
  const categoriesStore = useCategoriesMenuStore();
  const rootCategories: ICatMan[] = categoriesStore.categories.filter(hasSubcategories);

  const {selectCategory} = useCategoriesMenu();
</script>

<template>
    <div :class="b" data-testid="nav-main-menu-categories">
        <CpNavMenuMainCategoryCard
            v-for="cat in rootCategories"
            :key="cat.id"
            :category="cat"
            :selected="cat.id === categoriesStore.activeRoot?.id"
            @select-category="selectCategory"
        />
    </div>
</template>

<style scoped lang="scss">
  .cp-nav-menu-main-categories {
    overflow: auto;
    height: 100%;
    width: 31.11%;
    background-color: var(--color-primary);
    scrollbar-width: none;
    &::-webkit-scrollbar {
      width: 0;
    }
  }
</style>
